/**
 * Sticky chapter nav (desktop) — scroll-spy pin during programmatic Lenis scroll.
 */

/** Lenis `scrollTo` duration for StickyNav chapter jumps (seconds). */
export const STICKY_NAV_SCROLL_DURATION_S = 1.1;

/**
 * Lenis `userData` flag marking a StickyNav-initiated scroll. While set, the
 * active pill stays pinned to the clicked chapter instead of following IO.
 */
export const STICKY_NAV_SCROLL_PIN_KEY = 'stickyNavPin' as const;

/** Safety release if Lenis never fires `onComplete` (ms). */
export const STICKY_NAV_SCROLL_PIN_TIMEOUT_MS = 2000;
